import {Routes} from '@angular/router';
import {AuthGuard} from '../core/security/auth-guard.service';
import {ModulesEnum} from '../core/security/modules.enum';
import {RolesEnum} from '../core/security/roles.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {ProMessagingReportsSummaryComponent} from './summary/summary.component';

export const routes: Routes = [
  {
    path: '',
    component: ProMessagingReportsSummaryComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.ProMessagingGroup,
      package: ModulesEnum.ProMessagingReportsModule,
      permissions: [RolesEnum.ProMessagingReports_View, RolesEnum.ProMessagingReports_Edit, RolesEnum.ProMessagingReports_Delete],
      meta: {
        title: 'Reports',
        override: true,
        description: 'Messaging Reports',
        inSideMenu: true,
        iconClass: 'material-icons',
        iconClassCode: 'bar_chart',
        showDisabled: false
      }
    }
  },
];
